<template>
    <div>
       <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="日期">
                <el-date-picker
                      v-model=formInline.createTime
                      type="month"
                      value-format="yyyy-MM"
                      placeholder="选择月">
                    </el-date-picker>
            </el-form-item>
           <el-form-item>
               <el-button type="success" @click="getExportData">下载</el-button>
           </el-form-item>
       </el-form>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getExportDataApi} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    createTime:"",
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
            }
        },
        //挂载时候执行
        mounted(){
        },
        methods: {
            getExportData(){
                if(this.formInline.createTime == '' ){
                    alert("请选择月份");
                    return;
                }
                window.open(`${getExportDataApi}?createTime=${this.formInline.createTime}`)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/bill/orderRefundPayDownload.vue